import styles from './Spinner.module.css';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
}

/** A decorative spinner. The busy state it decorates announces itself. */
export function Spinner({ size = 'sm' }: SpinnerProps) {
  return <span className={`${styles.spinner} ${styles[size]}`} aria-hidden="true" />;
}
